import { render } from "./ActiveIntegrations.vue?vue&type=template&id=20506794"
import script from "./ActiveIntegrations.vue?vue&type=script&lang=js"
export * from "./ActiveIntegrations.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__